<template>
  <vipo v-if="vipoData" :videoId="vipoData.videoId" :collectionId="vipoData.collectionId"></vipo>
</template>

<script>

  // import PlayerSettingsMixin from '../mixins/PlayerSettingsMixin.vue'
  import axios from 'axios'
  import Vipo from '@/components/Vipo'

  export default {

    name: 'CMPPlayer', // Content Market Place Player

    // mixins: [PlayerSettingsMixin],

    components: {
      Vipo
    },

    props: {
      videoKey: {
        required: true
      }
    },

    data () {
      return {
        vipoData: null
      }
    },

    computed: {
      videoDataUrl() {
        return this.$settings && this.$settings.cmp ? this.$settings.cmp.baseUrl + 'embedCode/' + this.videoKey : ''
      }
    },

    mounted () {
      this.loadVideoData()
    },

    methods: {

      /**
       * Metadaten werden von VIPO API geladen
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      loadVideoData () {
        this.$l.log('loading videoKey', this.videoKey)

        axios.get( this.videoDataUrl, {}).then((response) => {

          var data = {};


          if(typeof(response.data.embedCode) == 'object') {
              data = response.data.embedCode;
          }


            this.$l.log(data);

          // added: 1502887334871
          // collectionId: "14498"
          // embedCode: "otymuxuoeta7sdn06gcpnpqz9vrslxs3ndayqbrzvgfyvdcoy357na"
          // partnerId: "BAU3Rnuj85pbp3b9lz2s1sqfshebee0jpa"
          // partnerUrls: (3) ["intouch.wunderweib.de", "www.bravo.de", "www.tvmovie.de"]
          // platform: "rtl2"
          // uid: "nj2wrhfye0t2amkqym720aui184u35ik4mszukn6dkglsjv3mw"
          // videoId: "43680"

          if(this.check(data.partnerUrls)) {
              if(data.platform == 'rtl2') {

                  this.vipoData = {
                    videoId: data.videoId,
                    collectionId: data.collectionId
                  }

              }
          }

          // this.videoData = response.data.video[0]

          // this.videoData.streamUrl = this.videoData.streamUrl.replace(/^http:\/\//i, 'https://');

          // // videoId: 211,
          // // formatId: 3373,
          // // boNr: "070-018856-0022",
          // // boId: 178163,
          // // title: "Chethrin war die größte Lästerhexe!",
          // // formatTitlel: "Love Island",
          // // duration: 90,
          // // description: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu erzählen. Der 25-Jährige verrät, welches Mädel er so richtig hot findet und mit wem er auf Love Island so gar nichts anfangen konnte.",
          // // seoTitle: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // // seoDescription: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // // streamUrl: "http://trans01dach-vh.akamaihd.net/i/delivery/7b/e4/7be4bf19-e07d-4b82-a690-a9f5c989ddc8/01SZ2D0010333WVB_,65,3850,650,1000,2350,250,1350,k.mp4.csmil/master.m3u8",
          // // image: "http://p-assets1.rtl2.de/4238199_01sz2d0010333wvb_video-love-island-interview-mike.png"


          // this.$manager.addItemData({
          //   source: 'bobyconnect',
          //   title: this.videoData.title,
          //   description: this.videoData.description,
          //   poster: this.videoData.image,
          //   format: this.videoData.formatTitlel,
          //   duration: this.videoData.duration,
          // })


          // this.setupVideo()
        }).catch((error) => {
          this.$warn('CMP API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        })
      },

      check(domains) {
        var valid = false
        var referrerTLD = this.$helpers.inIframe() ? this.$helpers.topLevelDomain(document.referrer) : this.$helpers.topLevelDomain(location.hostname)

        this.$l.log('validate tld', referrerTLD)

        // also allow rtl2.de domains
        domains.push('rtl2.de');

        for (var i = 0; i < domains.length; i++) {
          this.$l.log(this.$helpers.topLevelDomain(domains[i]));
          if(referrerTLD == this.$helpers.topLevelDomain(domains[i])) {
            valid = true;
            this.$l.log('hit for '+domains[i])
            break;
          }
        }

        this.$l.log('referrerCheck finished:',valid);

        if(valid == false) {
          this.$events.fire('fatalError', {msg: 'Ungültig :('})
        }


        return valid
      },

      /**
       * JWPlayer Setup
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      setupVideo () {

        var video = this.videoData;
        var adSchedule = {};

        // Preroll
        if(video.PREROLL && video.PREROLL != "") {
            adSchedule.preroll = {
                offset: "pre",
                tag: video.PREROLL
            };
        }

        // Midroll
        if(video.MIDROLL && video.MIDROLL != "") {
            adSchedule.midroll = {
                offset: "50%",
                tag: video.MIDROLL
            };
        }

        // Postroll
        if(video.POSTROLL && video.POSTROLL != "") {
            adSchedule.postroll = {
                offset: "post",
                tag: video.POSTROLL
            };
        }

        // Settings übernehmen
        if(adSchedule != []) {
          this.$manager.addOptions('advertising', {
            schedule: adSchedule
          })
        }
        else {
          this.$manager.addOptions({
            advertising: null
          })
        }

        // Playliste übernehmen
        this.$manager.addPlaylist([{
          title: video.title,
          image: video.image,
          sources: [{
            file: video.streamUrl,
            type: 'hls'
          }]
        }])

        // Setup fertig
        this.$manager.finalizeSetup()
      }


    }

  }
</script>



// WEBPACK FOOTER //
// src/components/CMP.vue